import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const communicationsStatusPageConfigurationRoute: InvariantJiraRoute = {
	name: 'communications-status-page-configuration',
	path: '/jira/communications/status-page/configuration/:pageId',
};
